import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent
} from "@softline/dynamic";
import { LagerstammListView } from "./list-view/lagerstamm.list-view";

export const lagerstammFieldOk: FieldOkConfig = {
  name: 'lagerstamm',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{lager}} - {{name1}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: LagerstammListView
    }
  }
  ]
};
export const lagerstammMultiselectFieldOk: FieldOkConfig = {
  name: 'lagerstamm',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{lager}} - {{name1}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkMultiselectListViewComponent,
    title: 'Auswahl',
    config: {
      component: LagerstammListView
    }
  }
  ]
};

export const lagerstammQueryFieldOk: FieldOkConfig = {
  name: 'lagerstamm',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{lager}} - {{name1}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: QueryFieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: LagerstammListView
    }
  }
  ]
};
